import { jsxs as e, jsx as r } from "react/jsx-runtime";
const t = ({ className: c, width: l = "8", height: o = "13" }) => /* @__PURE__ */ e(
  "svg",
  {
    className: c,
    width: l,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 13",
    fill: "none",
    children: [
      /* @__PURE__ */ r("circle", { cx: "1.5", cy: "1.5", r: "1.5", fill: "currentColor" }),
      /* @__PURE__ */ r("circle", { cx: "6.5", cy: "1.5", r: "1.5", fill: "currentColor" }),
      /* @__PURE__ */ r("circle", { cx: "1.5", cy: "6.5", r: "1.5", fill: "currentColor" }),
      /* @__PURE__ */ r("circle", { cx: "6.5", cy: "6.5", r: "1.5", fill: "currentColor" }),
      /* @__PURE__ */ r("circle", { cx: "1.5", cy: "11.5", r: "1.5", fill: "currentColor" }),
      /* @__PURE__ */ r("circle", { cx: "6.5", cy: "11.5", r: "1.5", fill: "currentColor" })
    ]
  }
);
export {
  t as default
};
